import React from "react";
import {    CART_ADD_RESET , CART_ADD_REQUEST ,CART_ADD_SUCCESS ,CART_ADD_FAIL , 
            GET_CART_LIST_SUCCESS , GET_CART_LIST_FAIL,
            CART_DELETE_RESET , CART_DELETE_REQUEST, CART_DELETE_SUCCESS , CART_DELETE_FAIL,
            STRIPE_PAYMENT_RESET , STRIPE_PAYMENT_REQUEST, STRIPE_PAYMENT_SUCCESS , STRIPE_PAYMENT_FAIL,
            PAYPAL_PAYMENT_RESET , PAYPAL_PAYMENT_REQUEST, PAYPAL_PAYMENT_SUCCESS , PAYPAL_PAYMENT_FAIL,
            PAYU_PAYMENT_RESET , PAYU_PAYMENT_REQUEST, PAYU_PAYMENT_SUCCESS , PAYU_PAYMENT_FAIL,
        } from "../../constants/PaymentConstants";

const initialStateDefault = {
    loading: false,
    status: false,
    data: null,
    error: null,
};

export const CartDataReducer = (state = initialStateDefault, action:any) =>{
    try {
         if(action.type === "GET_CART_LIST_SUCCESS"){
            return {
                ...state,
                loading:false,
                data:action.data
            }; 
        }        
        if(action.type === "GET_CART_LIST_FAIL"){
           
            return {
                ...state,
                login_data:action.data
            }; 
        }        
    } catch (error) {
        
    }
    return state;
}

const initialStateCartDelete = {
    loading_delete: false,
    status_delete: false,
    data_delete: null,
    error_delete: null,
};

export const CartDeleteReducer = (state = initialStateCartDelete, action: any) => {
    switch (action.type) {
        case CART_DELETE_RESET:
            return {
                ...initialStateCartDelete,
            }
        case CART_DELETE_REQUEST:
            return {
                ...state,
                loading_delete: true,
            }
        case CART_DELETE_SUCCESS:
            return {
                ...state,
                loading_delete: false,
                status_delete: true,
                data_delete: action.payload
            }
        case CART_DELETE_FAIL:
            return {
                ...state,
                loading_delete: false,
                status_delete: false,
                error_delete: action.payload
            }
        default:
            return state;
    }
};

const initialStateCartAdd = {
    loading_add: false,
    status_add: false,
    data_add: null,
    error_add: null,
};

export const CartAddReducer = (state = initialStateCartAdd, action: any) => {
    switch (action.type) {
        case CART_ADD_RESET:
            return {
                ...initialStateCartAdd,
            }
        case CART_ADD_REQUEST:
            return {
                ...state,
                loading_add: true,
            }
        case CART_ADD_SUCCESS:
            return {
                ...state,
                loading_add: false,
                status_add: true,
                data_add: action.payload
            }
        case CART_ADD_FAIL:
            return {
                ...state,
                loading_add: false,
                status_add: false,
                error_add: action.payload
            }
        default:
            return state;
    }
};


const initialStateStripePayment = {
    loading_stripe: false,
    status_stripe: false,
    data_stripe: null,
    error_stripe: null,
};

export const StripePaymentReducer = (state = initialStateStripePayment, action: any) => {
    switch (action.type) {
        case STRIPE_PAYMENT_RESET:
            return {
                ...initialStateStripePayment,
            }
        case STRIPE_PAYMENT_REQUEST:
            return {
                ...state,
                loading_stripe: true,
            }
        case STRIPE_PAYMENT_SUCCESS:
            return {
                ...state,
                loading_stripe: false,
                status_stripe: true,
                data_stripe: action.payload
            }
        case STRIPE_PAYMENT_FAIL:
            return {
                ...state,
                loading_stripe: false,
                status_stripe: false,
                error_stripe: action.payload
            }
        default:
            return state;
    }
};

const initialStatePaypalPayment = {
    loading_paypal: false,
    status_paypal: false,
    data_paypal: null,
    error_paypal: null,
};

export const PaypalPaymentReducer = (state = initialStatePaypalPayment, action: any) => {
    switch (action.type) {
        case PAYPAL_PAYMENT_RESET:
            return {
                ...initialStatePaypalPayment,
            }
        case PAYPAL_PAYMENT_REQUEST:
            return {
                ...state,
                loading_paypal: true,
            }
        case PAYPAL_PAYMENT_SUCCESS:
            return {
                ...state,
                loading_paypal: false,
                status_paypal: true,
                data_paypal: action.payload
            }
        case PAYPAL_PAYMENT_FAIL:
            return {
                ...state,
                loading_paypal: false,
                status_paypal: false,
                error_paypal: action.payload
            }
        default:
            return state;
    }
};

const initialStatePayuPayment = {
    loading_payu: false,
    status_payu: false,
    data_payu: null,
    error_payu: null,
};

export const PayuPaymentReducer = (state = initialStatePayuPayment, action: any) => {
    switch (action.type) {
        case PAYU_PAYMENT_RESET:
            return {
                ...initialStatePayuPayment,
            }
        case PAYU_PAYMENT_REQUEST:
            return {
                ...state,
                loading_payu: true,
            }
        case PAYU_PAYMENT_SUCCESS:
            return {
                ...state,
                loading_payu: false,
                status_payu: true,
                data_payu: action.payload
            }
        case PAYU_PAYMENT_FAIL:
            return {
                ...state,
                loading_payu: false,
                status_payu: false,
                error_payu: action.payload
            }
        default:
            return state;
    }
};